<template>
  <sliderBarDialogShell
    ref="sliderbar"
    :dialog-show="dialogShow"
    :dialog-title="title"
    @close="close"
    @submit="confirm"
    class="editLark"
  >
    <Form
      ref="form"
      @submit="submitHandle"
    ></Form>
  </sliderBarDialogShell>
</template>

<script>
import { saveConfig } from '@/api/sys/robitConfig/dingding'
import Form from '@/components/sys/robitCofig/dingding/Form'

export default {
  name: 'add',
  components:{
    Form,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      title: '增加钉钉推送渠道',
    }
  },
  computed: {
  },
  methods: {
    close(){
      this.$refs.form.$refs.form.clearValidate();
      this.$emit('close');
    },

    cancel(){
      this.close();
    },
    confirm() {
      this.$refs.form.validate();
    },
    submitHandle(formData){
      let params = {
          name: formData.robitName,
          desc: formData.desc,
          hookUrl: formData.hookUrl,
          secret: formData.secret,
          status: formData.status,
      }
      saveConfig(params).then((res) => {
        this.$refs.form.$refs.form.clearValidate();
        this.$refs.form.$refs.form.resetFields();

        this.$emit('add-success');
        this.$refs.form.reset();
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.addlinks-dialog {
  .el-select {
    width: 100%;
  }
}
</style>
